import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Auth relies on the httpOnly session cookie. The token is kept in memory only (never localStorage) as a same-tab fallback.
let memToken = null;
export const getToken = () => memToken;
export const setToken = (t) => { memToken = t; };
export const clearToken = () => { memToken = null; };

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const mediaUrl = (contentId) => `${API}/media/${contentId}`;

export default api;
